import { CSSProperties } from 'react';

// monthlyPaymentsStyles.ts
export const getMonthlyPaymentsStyles = (isMobile: boolean) => ({
  // Container principal
  container: {
    padding: isMobile ? '12px' : '24px'
  },

  // Título
  title: {
    fontSize: isMobile ? '20px' : '24px',
    marginBottom: isMobile ? '12px' : '24px'
  },

  // Container de controles
  controlsContainer: {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: 'center',
    gap: isMobile ? '8px' : '12px',
    marginBottom: '16px',
    padding: isMobile ? '12px' : '16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
    width: isMobile ? 'auto' : '90%'
  } as CSSProperties,

  // Navegação de mês
  monthNavigation: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: isMobile ? 'space-between' : 'flex-start',
    width: '100%',
    marginBottom: isMobile? '12px': '0'
  } as CSSProperties,

  // Botões de navegação
  navButton: {
    padding: isMobile ? '10px' : '8px',
    backgroundColor: '#17a2b8',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    minWidth: isMobile ? '44px' : 'auto'
  } as CSSProperties,

  // Container dos selects
  selectContainer: {
    display: 'flex',
    gap: '8px',
    flex: 1
  } as CSSProperties,

  // Container de filtros de status
  statusFiltersContainer: {
    display: 'flex',
    gap: isMobile ? '16px' : '12px',
    justifyContent: isMobile ? 'center' : 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap'
  } as CSSProperties,

  // Labels dos filtros
  filterLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: isMobile ? '16px' : '14px',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  } as CSSProperties,

  // Checkboxes
  filterCheckbox: {
    transform: isMobile ? 'scale(1.2)' : 'scale(1)'
  } as CSSProperties,

  // Botão de atualizar
  refreshButton: {
    padding: isMobile ? '10px 12px' : '8px 16px',
    backgroundColor: '#17a2b8',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: isMobile ? '16px' : '14px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minWidth: isMobile ? '44px' : 'auto'
  } as CSSProperties,

  // Container da lista de empresas
  companiesListContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: isMobile ? '12px' : '16px',
    width: '100%',
    maxWidth: isMobile ? '300px' : '750px'
  } as CSSProperties,

  // Card da empresa
  companyCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    overflow: 'hidden'
  } as CSSProperties,

  // Cabeçalho da empresa
  companyHeader: {
    padding: isMobile ? '12px' : '16px',
    backgroundColor: '#f8f9fa',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: isMobile ? 'flex-start' : 'center',
    gap: isMobile ? '8px' : '0',
    transition: 'background-color 0.2s'
  } as CSSProperties,

  // Container principal do cabeçalho
  companyHeaderMain: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%'
  } as CSSProperties,

  // Container de informações da empresa
  companyInfo: {
    flex: 1
  } as CSSProperties,

  // Nome da empresa
  companyName: {
    margin: 0,
    color: '#333',
    fontSize: isMobile ? '16px' : '18px',
    lineHeight: '1.2'
  } as CSSProperties,

  // Detalhes da empresa
  companyDetails: {
    fontSize: isMobile ? '12px' : '14px',
    color: '#6c757d',
    marginTop: '4px',
    lineHeight: '1.3'
  } as CSSProperties,

  // Container dos badges de status
  statusBadgesContainer: {
    display: 'flex',
    gap: isMobile ? '8px' : '12px',
    alignSelf: isMobile ? 'flex-end' : 'center',
    width: '300px',
    justifyContent:  'center'
  } as CSSProperties,

  // Badge de status pago
  paidBadge: {
    padding: isMobile ? '3px 8px' : '4px 12px',
    backgroundColor: '#d4edda',
    color: '#155724',
    borderRadius: '12px',
    fontSize: isMobile ? '11px' : '12px',
    fontWeight: 'bold'
  } as CSSProperties,

  // Badge de status pendente
  pendingBadge: {
    padding: isMobile ? '3px 8px' : '4px 12px',
    backgroundColor: '#fff3cd',
    color: '#856404',
    borderRadius: '12px',
    fontSize: isMobile ? '11px' : '12px',
    fontWeight: 'bold'
  } as CSSProperties,

  // Container expandido de pagamentos
  paymentsContainer: {
    padding: isMobile ? '12px' : '16px'
  } as CSSProperties,

  // Lista de pagamentos
  paymentsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: isMobile ? '8px' : '12px'
  } as CSSProperties,

  // Item de pagamento
  paymentItem: {
    padding: isMobile ? '10px' : '12px',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px',
    border: '1px solid #dee2e6',
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: 'space-between',
    alignItems: isMobile ? 'flex-start' : 'center',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    gap: isMobile ? '8px' : '16px'
  } as CSSProperties,

  // Informações do beneficiário
  beneficiaryInfo: {
    flex: 1
  } as CSSProperties,

  // Nome do beneficiário
  beneficiaryName: {
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '4px',
    fontSize: isMobile ? '14px' : '16px'
  } as CSSProperties,

  // Nome do projeto
  projectName: {
    fontSize: isMobile ? '12px' : '14px',
    color: '#6c757d',
    lineHeight: '1.3'
  } as CSSProperties,

  // Descrição
  description: {
    fontSize: isMobile ? '11px' : '12px',
    color: '#868e96',
    marginTop: '4px',
    lineHeight: '1.3'
  } as CSSProperties,

  // Container de valores e status
  valueStatusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: isMobile ? '8px' : '16px',
    alignSelf: isMobile ? 'flex-end' : 'center'
  } as CSSProperties,

  // Container de valores
  valueContainer: {
    textAlign: 'right'
  } as CSSProperties,

  // Valor principal
  mainValue: {
    fontSize: isMobile ? '14px' : '16px',
    fontWeight: 'bold',
    color: '#333'
  } as CSSProperties,

  // Status de pagamento
  paymentStatus: {
    fontSize: isMobile ? '10px' : '12px',
    marginTop: '2px'
  } as CSSProperties,

  // Indicador de status (círculo)
  statusIndicator: {
    width: isMobile ? '6px' : '8px',
    height: isMobile ? '6px' : '8px',
    borderRadius: '50%'
  } as CSSProperties,

  // Estado vazio
  emptyState: {
    textAlign: 'center',
    padding: isMobile ? '40px 20px' : '60px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  } as CSSProperties,

  // Título do estado vazio
  emptyStateTitle: {
    margin: '16px 0',
    color: '#495057',
    fontSize: isMobile ? '16px' : '18px'
  } as CSSProperties,

  // Descrição do estado vazio
  emptyStateDescription: {
    color: '#6c757d',
    marginBottom: '24px',
    fontSize: isMobile ? '14px' : '16px',
    lineHeight: '1.4'
  } as CSSProperties,

  // Botão do estado vazio
  emptyStateButton: {
    padding: isMobile ? '10px 20px' : '12px 24px',
    backgroundColor: '#4db0b1',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: isMobile ? '14px' : '16px',
    fontWeight: 'bold'
  } as CSSProperties,

  // Rodapé informativo
  footer: {
    marginTop: '16px',
    padding: isMobile ? '12px' : '16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px',
    fontSize: isMobile ? '12px' : '13px',
    color: '#6c757d',
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    alignItems: isMobile ? 'flex-start' : 'center',
    justifyContent: 'space-between',
    gap: isMobile ? '12px' : '0'
  } as CSSProperties,

  // Informações do rodapé
  footerInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  } as CSSProperties,

  // Texto do rodapé
  footerText: {
    lineHeight: '1.3'
  } as CSSProperties,

  // Container de botões do rodapé
  footerButtons: {
    display: 'flex',
    gap: isMobile ? '8px' : '12px',
    width: isMobile ? '100%' : 'auto'
  } as CSSProperties,

  // Botão secundário do rodapé
  footerSecondaryButton: {
    padding: isMobile ? '8px 12px' : '6px 12px',
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: isMobile ? '12px' : '12px',
    flex: isMobile ? 1 : 'none'
  } as CSSProperties,

  // Botão primário do rodapé
  footerPrimaryButton: {
    padding: isMobile ? '8px 12px' : '6px 12px',
    backgroundColor: '#4db0b1',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: isMobile ? '12px' : '12px',
    flex: isMobile ? 1 : 'none'
  } as CSSProperties,

  // Mensagem de nenhum pagamento encontrado
  noPaymentsMessage: {
    textAlign: 'center',
    padding: isMobile ? '16px' : '20px',
    color: '#6c757d',
    fontSize: isMobile ? '14px' : '16px'
  } as CSSProperties
});

// Cores dos borders dos cards de resumo
export const summaryCardBorders = {
  companies: '4px solid #17a2b8',
  beneficiaries: '4px solid #6f42c1',
  paid: '4px solid #28a745',
  pending: '4px solid #ffc107'
};

// Cores dos status de pagamento
export const paymentStatusColors = {
  paid: '#28a745',
  pending: '#dc3545'
};

// Cores dos indicadores de status
export const statusIndicatorColors = {
  paid: '#28a745',
  pending: '#ffc107'
};